import React from 'react';
import './Slider.css'


interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    onChange?: (value: any,) => void | React.ChangeEventHandler<HTMLInputElement>;
    onChange2?: (value: number, index?: number) => void;
    trackIndex?: number;
    small?: boolean
    // setVolume?: (val: number) => void;
}

const Slider = ({small, trackIndex, onChange, onChange2, ...restProps}: Props) => {
    return (
        // <div className="volume-slider">
            <input type="range" onChange={
                (e) => {
                    const val = e.target.value
                    onChange && onChange(val)
                    onChange2 && onChange2((Number(val)), trackIndex)

                }
            } min={0} max={1} step={0.1} defaultValue={1} {...restProps} className={`volume-slider ${ small ? 'lg:w-[40px]' : 'w-[50px] lg:w-[80px]'} h-[3px] bg-white rounded-full`}/>
        // </div>
    );
};

export default Slider;